import React, {ReactNode} from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  createStyles,
  makeStyles
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {INPUT_BORDER_COLOR, INPUT_LABEL_COLOR} from 'src/style/variable';
import TimePickerWrapper, {
  TimePickerWrapperProps
} from '../CustomDateTimePicker/TimePickerWrapper';

interface IDateInputField
  extends Omit<TimePickerWrapperProps, 'error' | 'onChange'> {
  label?: ReactNode;
  error?: Record<string, any>;
  onChange: (value: any) => void;
}

const useStyles = makeStyles(() => {
  return createStyles({
    formControl: {
      paddingBottom: 0,
      marginBottom: 0,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: INPUT_BORDER_COLOR
      },
      '& .MuiFormLabel-asterisk': {
        color: 'inherit'
      }
    },
    helperTextWrapper: {
      marginLeft: '0rem'
    }
  });
});

const TimeInputField = (props: IDateInputField): JSX.Element => {
  const {label, error, ...rest} = props;
  const classes = useStyles();
  const {t} = useTranslation();
  return (
    <FormControl
      error={!!error}
      fullWidth={true}
      variant="outlined"
      className={classes.formControl}
      required={rest?.required}>
      {label && (
        <InputLabel
          style={{
            position: 'static',
            transform: 'none',
            marginBottom: '0.5rem',
            fontSize: '1.1rem',
            color: INPUT_LABEL_COLOR,
            pointerEvents: 'auto'
          }}
          shrink>
          {label}
        </InputLabel>
      )}
      <TimePickerWrapper {...rest} error={!!error} />
      {error && (
        <FormHelperText className={classes.helperTextWrapper}>
          {t(error.message)}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default TimeInputField;
